import styled from 'styled-components';
import { Layout } from 'components/atoms/layout';
import { ProductiveHeading04 } from 'components/styles';
const { Content } = Layout;
export const Container = styled(Content)`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 88px 120px;
  align-items: flex-start;
  background: var(--white-100, #fff);

  @media (max-width: 480px) {
    padding: 48px 24px;
  }
`;
export const WelcomeHeading = styled.strong`
  ${ProductiveHeading04};
  font-weight: var(--heading-8-weight);
`;
export const Heading = styled.div`
  ${ProductiveHeading04};
  font-size: var(--heading-5-size);
`;
export const HeadingContainer = styled.div`
  display: flex;
  gap: var(--spacing-05);
  align-items: center;
  margin-bottom: var(--layout-05);
`;
export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HelperTitle = styled.div`
  margin-bottom: var(--spacing-04);
  font-size: var(--font-size-lg);
  font-weight: var(--heading-6-weight);
`;
